<template>
  <div class="list-view-type-tabs">
    <ul class="list-view-type-tabs__list">
        <li
            class="list-view-type-tabs__item"
            v-for="(tab, index) in tabs"
            :key="index"
            :class="[{'-active': activeTab === tab.value}, tab.value, {'-disabled': tab.count === 0}]"
            @click="switchTab(tab)"
        >
            <template v-if="tab.icon"><span :class="'icon-' + tab.icon"></span></template>
            <template>{{ $t(tab.label) }}</template>
             ({{ tab.count }})
        </li>
    </ul>
  </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import { mapOrderTypeToSortValue, orderTypes } from 'store/shared/sorterOptions'
    import { viewTypes } from '@/store/modules/search'

    export default {
        name: 'SearchListViewTypeTabs',
        props: {
            isPackageCustomerCustom: {
                type: Boolean
            }
        },
        data () {
            return {
                tabsRouteNames: {
                    learning_paths: 'learning-paths',
                    collections: 'collection-list',
                    courses: 'course-list',
                    live: 'live-events',
                    virtual_classrooms: 'virtual-classrooms',
                    all: 'all-content'
                }
            }
        },
        computed: {
            ...mapGetters({
                activeTab: 'Search/getViewType',
                viewTypeCounts: 'Search/viewTypeCounts',
                searchInProgress: 'Search/isSearchInProgress',
                currentUser: 'User/getCurrentUser',
                isLoggedIn: 'isLoggedIn'
            }),
            tabs () {
                const viewTypeTabs = [
                    { value: 'learning_paths', label: 'CourseItemTypeTabs.learning_paths', icon: 'crown', count: this.viewTypeCounts.learning_paths },
                    { value: 'collections', label: 'CourseItemTypeTabs.collections', icon: 'stack', count: this.viewTypeCounts.collections },
                    { value: 'courses', label: 'CourseItemTypeTabs.courses', icon: 'play', count: this.viewTypeCounts.courses },
                    { value: 'live', label: 'CourseItemTypeTabs.live_events', icon: 'feed', count: this.viewTypeCounts.live },
                    { value: 'virtual_classrooms', label: 'CourseItemTypeTabs.virtual_classrooms', icon: 'globe', count: this.viewTypeCounts.virtual_classrooms },
                    { value: 'all', label: 'CourseItemTypeTabs.all_content', count: this.viewTypeCounts.all }
                ]
                if (this.isLoggedIn && !this.hasAccessToDigitalClassrooms && this.hasAccessToDigitalClassrooms !== null) {
                    return viewTypeTabs.filter(viewTypeTab => viewTypeTab.value !== 'virtual_classrooms')
                }
                return viewTypeTabs
            },
            hasAccessToDigitalClassrooms () {
                return this.currentUser.hasAccessToDigitalClassrooms
            }
        },
        methods: {
            switchTab (tab) {
                if (tab.count === 0) {
                    return
                }
                this.$store.dispatch('Search/setViewType', tab.value)

                switch (tab.value) {
                    case viewTypes.collections:
                    case viewTypes.courses:
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.NEW_TO_OLD))
                        break
                    case viewTypes.liveEvents:
                    case viewTypes.virtualClassrooms:
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.OLD_TO_NEW))
                        break
                    case viewTypes.all:
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.A_TO_Z))
                }

                if (Object.keys(this.$route.params).length === 0) {
                    this.$router.replace({ name: 'all-packages-' + this.tabsRouteNames[tab.value] })
                } else {
                    this.$router.replace({ name: this.tabsRouteNames[tab.value] })
                }
            },
            doNotShowEmptyTabs () {
                if (this.searchInProgress) {
                    return
                }
                let isActiveTabEmpty = this.tabs.find(el => el.value === this.activeTab).count === 0

                if (this.isPackageCustomerCustom) {
                    if (isActiveTabEmpty && this.viewTypeCounts.collections > 0) {
                        this.$store.dispatch('Search/setViewType', viewTypes.collections)
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.NEW_TO_OLD))
                        return
                    } else if (isActiveTabEmpty && this.viewTypeCounts.courses > 0) {
                        this.$store.dispatch('Search/setViewType', viewTypes.courses)
                        this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.NEW_TO_OLD))
                        return
                    }
                }

                if (isActiveTabEmpty && this.viewTypeCounts.all > 0) {
                    this.$store.dispatch('Search/setViewType', viewTypes.all)
                    this.$store.dispatch('Search/setSort', mapOrderTypeToSortValue(orderTypes.A_TO_Z))
                }

            }
        },
        watch: {
            activeTab: {
                handler: 'doNotShowEmptyTabs',
                immediate: true
            },
            viewTypeCounts: {
                handler: 'doNotShowEmptyTabs',
                immediate: true
            }
        }
    }
</script>
<style scoped lang="scss">
.list-view-type-tabs {
    padding: 0 0 30px;

    &__list {
        display: flex;
        flex-direction: row;
        border-bottom: 1px solid $quill_gray;
        min-height: 42px;

        [class*="mobile"] & {
            flex-wrap: wrap;
            justify-content: center;
            height: 100%;
        }
    }

    &__item:not(:first-child) {
        [class*="desktop"] & {
            margin: 0 0 0 15px;
        }
    }

    &__item {
        min-height: 42px;
        padding: 0 20px;
        background: $heavy_metal;
        color: $white;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        font-family: Nunito-Regular, sans-serif;

        [class*="desktop"] & {
            gap: 12px;
        }

        [class*="mobile"] & {
            padding: 8px 6px;
            font-size: 1.4rem;
            margin: 0 7px 10px 0;
            flex: 1;
        }

        &.-disabled {
            background: $bright_gray;
            border: 1px solid $alto;
            color: $manatee;
            cursor: default;

            .icon-globe {
                background: url('../../../../assets/images/thumbnails/globe-grey.svg') no-repeat;
            }
        }

        &.-active {
            background: $rust_orange;
            color: $white;
        }
    }

    span[class*="icon-"] {
        font-size: 1.8rem;
        [class*="mobile"] & {
            margin: 0 6px 0 0;
            font-size: 1.8rem;
        }
    }

    .icon-globe {
        background: url('../../../../assets/images/thumbnails/globe-white.svg') no-repeat;
        min-width: 18px;
        height: 18px;
    }
}
</style>
